import { useState } from 'preact/hooks';

/** Shortens `https://host/a/b/c/` to `host/…/c`; the full URL is the tooltip and expands on click. */
export function compactUrl(url: string): string {
  try {
    const u = new URL(url);
    const parts = u.pathname.split('/').filter(Boolean);
    const path = parts.length === 0 ? '' : parts.length === 1 ? `/${parts[0]}` : `/…/${parts[parts.length - 1]}`;
    return u.host + path;
  } catch {
    return url;
  }
}

export function UrlCompact({ url, class: cls = '' }: { url: string; class?: string }) {
  const [open, setOpen] = useState(false);
  const short = compactUrl(url);
  if (short === url.replace(/^https?:\/\//, '').replace(/\/$/, '')) {
    return <span class={`url-compact ${cls}`} title={url}>{short}</span>;
  }
  return (
    <span
      class={`url-compact expandable ${open ? 'open' : ''} ${cls}`}
      title={open ? 'Click to shorten' : url}
      role="button"
      tabIndex={0}
      onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); } }}
    >
      {open ? url : short}
    </span>
  );
}
